export const toPlural = (s: string) => (s[s.length - 1] === 's' ? `${s}'` : `${s}'s`);
